import React, {FC, useEffect, useState} from "react"
import Select from "@irati/ui/src/FormItem/Select"
import Validation from "@irati/utils/validation"
import {SelectionListOption} from "@irati-internal/app/src/components/RegionForm/RegionForm"
import homepageService from "@irati/deals/services/homepage"
import {PerksHomepage, Region} from "@irati/types"
import {PerksHomepageActiveState, QueryPerksHomepagesArgs} from "@irati/types/generated/ops"

interface Props {
  region: Partial<Region>,
  onChange: (fieldName: string, value: any) => void
}

const RegionHomepage: FC<Props> = ({region, onChange}) => {
  const [homepageSelectionList, setHomepageSelectionList] = useState<SelectionListOption[]>([])

  useEffect(() => {
    getHomepageSelectionList().then((data) => {
      const mappedHomepages = data.map((homepage: PerksHomepage) => {
        const {name, uuid} = homepage
        return {value: uuid, label: name}
      })
      setHomepageSelectionList(mappedHomepages)
    })
  }, [])

  const getHomepageSelectionList = async(): Promise<PerksHomepage[]> => {
    const request = async(initial: PerksHomepage[], args: QueryPerksHomepagesArgs): Promise<PerksHomepage[]> => {
      const response = await homepageService.list(args)
      const data = [...initial, ...response.results]
      const {cursor, hasMore} = response
      if (hasMore) {
        return request(data, {cursor})
      }
      return data
    }

    return request([], {limit: 200, state: PerksHomepageActiveState.Active})
  }

  return (
    <Select
      name="type"
      label="Homepage"
      hint={
        <>
          This is the screen seen at <a href="https://home.perkbox.com/perks/discover">https://home.perkbox.com/perks/discover</a>
        </>
      }
      value={region.homepageId}
      isClearable={false}
      options={homepageSelectionList}
      onChange={(newValue) => onChange("homepageId", newValue)}
      validation={Validation.string("Please select a homepage.")} />
  )
}

export default RegionHomepage
